import React, { createContext, useState, useContext, useCallback } from 'react';

const SendToDeereContext = createContext();

export const SendToDeereProvider = ({ children }) => {
  const [dialogProps, setDialogProps] = useState({});

  const open = useCallback(
    (props) => setDialogProps({ ...props, isOpen: true }),
    [],
  );

  const close = useCallback(() => setDialogProps({}), []);

  return (
    <SendToDeereContext.Provider value={{ dialogProps, open, close }}>
      {children}
    </SendToDeereContext.Provider>
  );
};

export const useSendToDeere = () => useContext(SendToDeereContext);
